import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

/**
 * 301 Redirect page for /studystream/ -> /study-stream/
 * This page includes proper SEO signals for search engines:
 * - Canonical URL pointing to /study-stream/
 * - Meta refresh redirect
 * - noindex to prevent indexing
 * - JavaScript redirect for browsers
 */
const StudyStreamRedirect = () => {
  useEffect(() => {
    // Client-side redirect
    window.location.replace("/study-stream/");
  }, []);

  return (
    <>
      <Helmet>
        <title>Redirecting to Study Stream | CSW</title>
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://csw.live/study-stream/" />
        <meta httpEquiv="refresh" content="0;url=/study-stream/" />
        {/* Add HTTP status hint for crawlers */}
        <meta name="prerender-status-code" content="301" />
      </Helmet>
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <p className="text-muted-foreground">Redirecting to Study Stream...</p>
          <a href="/study-stream/" className="text-primary hover:underline mt-2 block">
            Click here if not redirected
          </a>
        </div>
      </div>
    </>
  );
};

export default StudyStreamRedirect;
